/* ============================================================================
   LED.nl — productpagina, gedrag
   ----------------------------------------------------------------------------
   Eén bestand voor de hele PDP. Alles is defensief: elk onderdeel bestaat
   alleen als de bijbehorende markup er is, zodat een uitgeschakelde sectie
   nooit de rest meesleurt.

   Zichtbare tekst komt zonder uitzondering uit data-attributen die door
   Liquid uit de sectie-instellingen worden gevuld — tekst die in JavaScript
   staat is namelijk niet vertaalbaar door Translate & Adapt.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------------------
     Geld opmaken. Shopify's money-filter draait server-side; hier hebben we
     hetzelfde nodig voor prijzen die we in de browser uitrekenen. We leiden
     het formaat af van een bedrag dat Liquid al heeft gerenderd, zodat een
     andere market (Duitsland) vanzelf goed gaat.
     ------------------------------------------------------------------------ */
  var moneyFormat = (function () {
    var sample = $('[data-pdp-price-incl]');
    var text = sample ? sample.textContent.trim() : '€ 0,00';
    var comma = text.indexOf(',') > text.indexOf('.');
    return {
      prefix: text.replace(/[\d.,\s]+$/, '').trim(),
      comma: comma
    };
  })();

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2);
    var parts = v.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.comma ? '.' : ',');
    var out = whole + (moneyFormat.comma ? ',' : '.') + parts[1];
    return (moneyFormat.prefix ? moneyFormat.prefix + ' ' : '') + out;
  }

  /* --------------------------------------------------------------------------
     1. GALERIJ
     De track is een scroll-snap carrousel, dus swipen werkt zonder JavaScript.
     Hier houden we alleen de teller, de actieve miniatuur en de pijlen bij.
     ------------------------------------------------------------------------ */
  (function gallery() {
    var root = $('[data-pdp-gallery]');
    if (!root) return;

    var track = $('[data-pdp-track]', root);
    if (!track) return;

    var slides = $$('[data-pdp-slide]', track);
    var thumbs = $$('[data-pdp-thumb]', root);
    var counter = $('[data-pdp-count]', root);
    var prev = $('[data-pdp-prev]', root);
    var next = $('[data-pdp-next]', root);
    if (slides.length < 2) return;

    var current = 0;

    var wisselTimer = null;
    var onderweg = null;   // doel van een wissel die nog aan het uitvagen is
    var WISSEL_MS = 130;   // gelijk aan de transition in pdp-custom.css

    function spring(idx) {
      // Bewust géén smooth: op deze track blijft een vloeiende scroll steken
      // op positie 0 — zowel via scroll-behavior in CSS als via
      // scrollTo({behavior:'smooth'}). Het theme kaapt het scrollgedrag.
      track.scrollLeft = slides[idx].offsetLeft - track.offsetLeft;
      sync();
    }

    // Een stap vooruit of terug telt vanaf het doel van een lopende wissel:
    // twee snelle tikken op de pijl gaan dan twee foto's verder, niet één.
    function stap(n) { goTo((onderweg !== null ? onderweg : current) + n); }

    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      if (reduceMotion) { spring(idx); return; }
      // De sprong zelf blijft direct (zie spring), maar hij gebeurt terwijl de
      // foto even weg is: kort uitvagen, wisselen, weer invagen. Een kale
      // sprong oogde hard (verzoek eigenaar, 5 okt 2026). Alleen bij een tik
      // op een pijl of miniatuur; swipen schuift al vanzelf.
      // Een tweede tik tijdens het vagen vervangt het doel, zonder de
      // overgang opnieuw te starten.
      clearTimeout(wisselTimer);
      onderweg = idx;
      track.classList.add('is-wissel');
      wisselTimer = setTimeout(function () {
        onderweg = null;
        spring(idx);
        track.classList.remove('is-wissel');
      }, WISSEL_MS);
    }

    // De miniaturenstrook laten meelopen met de foto die in beeld staat.
    // Zonder dit blijft de actieve miniatuur bij foto 4 en verder buiten
    // beeld en lijkt de strook stil te staan.
    function keepThumbVisible(i) {
      var thumb = thumbs[i];
      if (!thumb) return;
      var strip = thumb.parentElement;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;

      var left = thumb.offsetLeft - strip.offsetLeft;
      var right = left + thumb.offsetWidth;
      var marge = 12;
      var doel = null;

      if (left < strip.scrollLeft + marge) {
        doel = left - marge;
      } else if (right > strip.scrollLeft + strip.clientWidth - marge) {
        doel = right - strip.clientWidth + marge;
      }
      if (doel === null) return;

      doel = Math.max(0, Math.min(doel, strip.scrollWidth - strip.clientWidth));
      strip.scrollLeft = doel;
    }

    function sync() {
      // Welke slide staat het dichtst bij het midden van de track?
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (best === current) return;
      current = best;

      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      keepThumbVisible(best);
      if (counter) counter.textContent = (best + 1) + '/' + slides.length;
      if (prev) prev.hidden = best === 0;
      if (next) next.hidden = best === slides.length - 1;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.pdpThumb, 10)); });
    });
    if (prev) prev.addEventListener('click', function () { stap(-1); });
    if (next) next.addEventListener('click', function () { stap(1); });

    // Pijltjestoetsen wanneer de focus in de galerij staat.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { stap(-1); }
      else if (e.key === 'ArrowRight') { stap(1); }
    });

    if (prev) prev.hidden = true;
    sync();
  })();

  /* --------------------------------------------------------------------------
     2. HOEVEELHEID
     ------------------------------------------------------------------------ */
  function getQtyInput() { return $('[data-pdp-qty-input]'); }

  // Wordt door de staffel (onderdeel 4) gevuld zodra die getekend is, zodat
  // de bewaking hieronder de actieve chip kan bijwerken.
  var markTier = function () {};

  (function quantity() {
    var input = getQtyInput();
    if (!input) return;

    /* Bewaking van het aantal. De widget van Orichi staat verborgen op de
       pagina (wij tekenen de staffel zelf) maar draait wel, en kiest bij het
       laden zijn eerste staffelregel. Begint een campagne niet bij 1 stuk —
       "TL - 4 stuks" bijvoorbeeld — dan schrijft hij 4 in dit veld, zonder
       event. Gemeten op 5 okt 2026: het veld stond op 4, onze chip op "Los
       stuk" en de teller in de sticky balk op 1; wie daar op de koopknop
       drukte kreeg er vier.

       Daarom: zolang de bezoeker zelf nog niets heeft aangeraakt blijft het
       aantal wat Liquid heeft neergezet. Daarna mag elk script het veld
       zetten (de lichtplanner doet dat ook), en lopen de sticky teller en de
       staffelchip direct mee, ook als er geen event volgt. */
    var start = input.defaultValue || '1';
    var aangeraakt = false;
    function raakAan() { aangeraakt = true; }
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (type) {
      document.addEventListener(type, raakAan, { capture: true, passive: true, once: true });
    });

    var eigen = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (eigen && eigen.get && eigen.set) {
      if (eigen.get.call(input) !== start) eigen.set.call(input, start);
      Object.defineProperty(input, 'value', {
        configurable: true,
        get: function () { return eigen.get.call(this); },
        set: function (v) {
          if (!aangeraakt && String(v) !== start) return;
          eigen.set.call(this, v);
          spiegel();
          markTier(parseInt(v, 10) || 1);
        }
      });
    }

    // De teller in de sticky koopbalk toont hetzelfde getal maar is géén
    // tweede invoerveld: één veld blijft de bron, de rest spiegelt mee.
    function spiegel() {
      var v = parseInt(input.value, 10) || 1;
      $$('[data-pdp-qty-mirror]').forEach(function (el) { el.textContent = v; });
    }

    // De knoppen worden document-breed gebonden, dus die in de sticky balk
    // doen automatisch mee zonder eigen afhandeling.
    $$('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.pdpQty, 10) || 1;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) input.value = 1;
      spiegel();
    });

    // Ook meelopen als iets anders het veld zet, bijvoorbeeld een klik op
    // een staffelchip.
    input.addEventListener('input', spiegel);
    spiegel();
  })();

  /* --------------------------------------------------------------------------
     3. LEVERBELOFTE MET AFTELKLOK
     Rekent altijd in Europe/Amsterdam, ongeacht de klok van de bezoeker.
     Weekenden en ingestelde feestdagen tellen niet als werkdag. Er wordt
     nooit een tijdstip binnen de dag beloofd — PostNL garandeert geen
     ochtendlevering.
     ------------------------------------------------------------------------ */
  (function delivery() {
    var root = $('[data-pdp-delivery]');
    if (!root) return;
    var out = $('[data-pdp-delivery-text]', root);
    if (!out) return;

    var t = {
      locale: root.dataset.locale || 'nl',
      tomorrow: root.dataset.lblTomorrow || 'morgen',
      dayAfter: root.dataset.lblDayafter || 'overmorgen',
      pattern: root.dataset.lblPattern || '[[dag]] in huis',
      countdown: root.dataset.lblCountdown || 'Bestel binnen [[tijd]]',
      nextday: root.dataset.lblNextday || 'bestel voor [[tijd]] op de eerstvolgende werkdag'
    };

    var cutoffStr = root.dataset.cutoff || '13:30';
    var cutoff = cutoffStr.split(':');
    var cutoffH = parseInt(cutoff[0], 10);
    var cutoffM = parseInt(cutoff[1] || '0', 10);

    var closed = (root.dataset.closedDates || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);

    function nowInNL() {
      var p = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Amsterdam',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
      return {
        date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)),
        h: +p.hour % 24, m: +p.minute, s: +p.second
      };
    }

    function iso(d) { return d.toISOString().slice(0, 10); }
    function isWorkday(d) {
      var day = d.getUTCDay();
      if (day === 0 || day === 6) return false;
      return closed.indexOf(iso(d)) === -1;
    }
    function addDays(d, n) {
      var c = new Date(d.getTime());
      c.setUTCDate(c.getUTCDate() + n);
      return c;
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function render() {
      var n = nowInNL();
      var today = n.date;
      var nowSec = n.h * 3600 + n.m * 60 + n.s;
      var cutSec = cutoffH * 3600 + cutoffM * 60;
      var beforeCutoff = nowSec < cutSec;

      var dispatch = new Date(today.getTime());
      if (!(isWorkday(dispatch) && beforeCutoff)) {
        do { dispatch = addDays(dispatch, 1); } while (!isWorkday(dispatch));
      }

      // Bezorging: de eerstvolgende dag die geen zondag of gesloten dag is.
      var delivery = addDays(dispatch, 1);
      while (delivery.getUTCDay() === 0 || closed.indexOf(iso(delivery)) !== -1) {
        delivery = addDays(delivery, 1);
      }

      var diff = Math.round((delivery - today) / 86400000);
      var label;
      if (diff === 1) label = t.tomorrow;
      else if (diff === 2) label = t.dayAfter;
      else label = new Intl.DateTimeFormat(t.locale, { weekday: 'long', timeZone: 'UTC' }).format(delivery);

      var dag = label.charAt(0).toUpperCase() + label.slice(1);
      var html = '<span class="pdp-delivery__day">' + t.pattern.replace('[[dag]]', dag) + '</span>';

      if (iso(dispatch) === iso(today)) {
        var rest = cutSec - nowSec;
        var hrs = Math.floor(rest / 3600);
        var min = Math.floor((rest % 3600) / 60);
        var sec = rest % 60;
        var clock = hrs > 0 ? (hrs + ':' + pad(min) + ':' + pad(sec)) : (pad(min) + ':' + pad(sec));
        html += ' <span class="pdp-delivery__rest">' +
                t.countdown.replace('[[tijd]]', '<span class="pdp-delivery__clock">' + clock + '</span>') +
                '</span>';
        // Het laatste uur krijgt een andere kleur; daaronder wordt het dringend.
        root.classList.toggle('pdp-delivery--urgent', rest < 3600);
      } else {
        // Na de cut-off. Niet zeggen "bestel voor 13:30 op de eerstvolgende
        // werkdag" — dat leest alsof je nú niets meer kunt bestellen. Wat er
        // feitelijk gebeurt is dat de bestelling de eerstvolgende werkdag de
        // deur uit gaat, en die dag noemen we.
        var dispatchDiff = Math.round((dispatch - today) / 86400000);
        var dispatchLabel = dispatchDiff === 1
          ? t.tomorrow
          : new Intl.DateTimeFormat(t.locale, { weekday: 'long', timeZone: 'UTC' }).format(dispatch);
        html += ' <span class="pdp-delivery__rest">' + t.nextday.replace('[[dag]]', dispatchLabel) + '</span>';
        root.classList.remove('pdp-delivery--urgent');
      }
      out.innerHTML = html;
    }

    render();
    // Elke seconde: de klok telt echt af. Staat het tabblad op de achtergrond,
    // dan slaan we het over — dat scheelt batterij en de klok wordt bij
    // terugkeer meteen bijgewerkt.
    setInterval(function () { if (!document.hidden) render(); }, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
  })();

  /* --------------------------------------------------------------------------
     4. STAFFELKORTING
     De regels komen uit de app-embed van Orichi Volume Discount. Wij tekenen
     ze zelf, zodat ze bij de huisstijl passen. Klikken zet alleen de
     hoeveelheid: de korting wordt door de app automatisch op regelniveau in
     de winkelwagen verrekend (geverifieerd 4 aug 2026).

     Vinden we geen regels, dan doen we niets en blijft Orichi's eigen widget
     staan als vangnet.
     ------------------------------------------------------------------------ */
  // Sets óf staffel, nooit allebei (regel eigenaar, 10 sep 2026). De
  // set-kiezer (snippet pdp-pack-picker, alleen de variant met echte sets)
  // staat standaard uit en verschijnt pas als vaststaat dat er géén staffel
  // op de pagina komt. De staffel heeft voorrang.
  function toonSets() {
    $$('[data-pdp-packs-sets]').forEach(function (el) { el.classList.add('is-zonder-staffel'); });
  }

  (function tiers() {
    var host = $('[data-pdp-tiers]');
    if (!host) { toonSets(); return; }

    var productId = String(host.dataset.productId || '');
    var collections = (host.dataset.collections || '').split(',').filter(Boolean);
    var tags = (host.dataset.tags || '').split('||').filter(Boolean);
    var basePrice = parseInt(host.dataset.price, 10) || 0;

    var L = {
      title: host.dataset.lblTitle || 'Meer stuks, lagere prijs',
      hint: host.dataset.lblHint || '',
      single: host.dataset.lblSingle || 'Los stuk',
      each: host.dataset.lblEach || 'per stuk',
      save: host.dataset.lblSave || '[[procent]]% korting',
      pieces: host.dataset.lblPieces || '[[n]] stuks',
      foot: host.dataset.foot || ''
    };

    function idOf(gid) { return String(gid || '').split('/').pop(); }

    // Campagnes die Orichi wél in de paginagegevens meestuurt (met active: true),
    // maar die de kortingsfunctie in de winkelwagen niet meer toepast. Gemeten op
    // 10 aug 2026: campagne 2626 "Test" belooft 10% bij 4 stuks op vier TL-buizen,
    // terwijl de wagen daar "TL  - 4 stuks" á 2,5% geeft. Zonder deze lijst belooft
    // de productpagina een korting die de kassa niet nakomt.
    //   Dit is een pleister: de echte oplossing is de campagne in de Orichi-app
    //   verwijderen. Staat die er niet meer, dan mag deze lijst leeg.
    var DODE_CAMPAGNES = [2626];

    function findCampaigns() {
      var vol = window.orichiVolume;
      if (!vol || !Array.isArray(vol.orichiVolumeDiscounts)) return null;

      var matches = vol.orichiVolumeDiscounts.filter(function (c) {
        if (!c.active) return false;
        if (DODE_CAMPAGNES.indexOf(Number(c.id)) !== -1) return false;

        // Uitsluitingen gaan vóór insluitingen.
        if (c.exSpecificProducts && (c.products || []).some(function (p) {
          return p.isExclude && idOf(p.productId) === productId;
        })) return false;
        if (c.exAllProductsInCollections && (c.collections || []).some(function (x) {
          return x.isExclude && collections.indexOf(idOf(x.collectionId)) !== -1;
        })) return false;

        if (c.allProducts) return true;
        if (c.specificProducts && (c.products || []).some(function (p) {
          return !p.isExclude && idOf(p.productId) === productId;
        })) return true;
        if (c.allProductsInCollection && (c.collections || []).some(function (x) {
          return !x.isExclude && collections.indexOf(idOf(x.collectionId)) !== -1;
        })) return true;
        if (c.specificProductTags && (c.tags || []).some(function (tg) {
          return tags.indexOf(tg) !== -1;
        })) return true;
        return false;
      });

      if (!matches.length) return null;

      // Meerdere campagnes kunnen op één product slaan (een collectieregel én
      // een productregel). De app past er één toe; wij tonen de campagne met
      // de hoogste maximale korting, want dat is wat de klant kan halen.
      var best = null, bestMax = -1;
      matches.forEach(function (c) {
        (c.volumeDiscounts || []).forEach(function (vd) {
          if (!vd.active) return;
          var max = (vd.rules || []).reduce(function (m, r) {
            return r.discountType === 'percentage_discount' ? Math.max(m, r.amount) : m;
          }, 0);
          if (max > bestMax) { bestMax = max; best = vd; }
        });
      });
      return best;
    }

    function build(vd) {
      var rules = (vd.rules || []).slice()
        .filter(function (r) { return r.quantity > 0; })
        .sort(function (a, b) { return a.quantity - b.quantity; });
      if (!rules.length) return false;
      // Alleen een echte staffel telt: minstens één regel met korting. Een
      // campagne met alleen een 1-stuks-regel tekent geen tabel, en dan
      // mogen de sets gewoon blijven staan.
      if (!rules.some(function (r) { return r.discountType === 'percentage_discount' && r.amount > 0; })) return false;

      // Begint de staffel niet bij 1, dan zetten we zelf een regel voor het
      // losse stuk erboven. Zonder die regel lijkt het alsof je er minstens
      // vier moet afnemen — dat is bij drie van de zes campagnes het geval.
      if (rules[0].quantity > 1) {
        rules.unshift({ quantity: 1, discountType: 'none', amount: 0, _synthetic: true });
      }

      var wrap = document.createElement('div');
      wrap.className = 'pdp-tiers';

      var head = document.createElement('div');
      head.className = 'pdp-tiers__head';
      var h = document.createElement('p');
      h.className = 'pdp-tiers__title';
      h.textContent = L.title;
      head.appendChild(h);
      if (L.hint) {
        var hint = document.createElement('span');
        hint.className = 'pdp-tiers__hint';
        hint.textContent = L.hint;
        head.appendChild(hint);
      }
      wrap.appendChild(head);

      var list = document.createElement('div');
      list.className = 'pdp-tiers__list';
      // Op mobiel worden de regels tegels naast elkaar (10 sep 2026). Dat past
      // tot vier stuks; bij meer blijft ook op mobiel de lijst staan.
      if (rules.length <= 4) list.classList.add('pdp-tiers__list--tegels');

      rules.forEach(function (r) {
        var pct = r.discountType === 'percentage_discount' ? r.amount : 0;
        // Orichi trekt de korting per stuk af en kapt daarbij de centen af, niet
        // afrondend: bij € 7,49 en 2,5% rekent de wagen € 0,18 korting (7,49 x
        // 0,025 = 0,187), dus € 7,31 per stuk. Met Math.round kwamen wij op
        // € 7,30 en stond er een cent te weinig op de productpagina.
        var each = basePrice - Math.floor(basePrice * pct / 100);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-tier';
        btn.dataset.qty = r.quantity;
        btn.setAttribute('aria-current', 'false');

        var qty = document.createElement('span');
        qty.className = 'pdp-tier__qty';
        qty.textContent = r.quantity === 1 ? L.single : L.pieces.replace('[[n]]', r.quantity);
        // De eigen titel van de app als ondertitel, maar alleen als hij iets
        // toevoegt: veel regels heten letterlijk "4 stuks".
        var sub = (r.subtitle || '').trim();
        if (sub && sub.toLowerCase() !== qty.textContent.toLowerCase()) {
          var small = document.createElement('small');
          small.textContent = sub;
          qty.appendChild(small);
        }
        btn.appendChild(qty);

        var price = document.createElement('span');
        price.className = 'pdp-tier__each';
        price.textContent = money(each);
        var perLabel = document.createElement('small');
        perLabel.textContent = L.each;
        price.appendChild(perLabel);
        btn.appendChild(price);

        var save = document.createElement('span');
        save.className = pct > 0 ? 'pdp-tier__save' : 'pdp-tier__save pdp-tier__save--none';
        save.textContent = pct > 0 ? L.save.replace('[[procent]]', String(pct).replace('.', ',')) : '—';
        btn.appendChild(save);

        // Kort label voor de tegels op mobiel: alleen "−7,5%". Het volledige
        // label ("7,5% korting") past niet in een tegel van ±75px; de CSS toont
        // op mobiel het een en op desktop het ander, nooit beide.
        if (pct > 0) {
          var kort = document.createElement('span');
          kort.className = 'pdp-tier__kort';
          kort.textContent = '−' + String(pct).replace('.', ',') + '%';
          btn.appendChild(kort);
        }

        btn.addEventListener('click', function () {
          var input = getQtyInput();
          if (!input) return;
          input.value = r.quantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          mark(r.quantity);
        });

        list.appendChild(btn);
      });

      wrap.appendChild(list);

      if (L.foot) {
        var foot = document.createElement('div');
        foot.className = 'pdp-tiers__foot';
        foot.innerHTML = L.foot;
        wrap.appendChild(foot);
      }

      host.appendChild(wrap);
      markTier = mark;
      // Pas nu Orichi's eigen widget verbergen: staat onze tabel er niet,
      // dan moet die van hen blijven staan.
      document.body.classList.add('pdp-has-own-tiers');

      var input = getQtyInput();
      if (input) {
        input.addEventListener('change', function () { mark(parseInt(input.value, 10) || 1); });
        mark(parseInt(input.value, 10) || 1);
      }
      return true;
    }

    // Welke staffel geldt bij dit aantal? De hoogste drempel die je haalt.
    function mark(qty) {
      var best = null;
      $$('.pdp-tier').forEach(function (b) {
        var q = parseInt(b.dataset.qty, 10);
        b.setAttribute('aria-current', 'false');
        if (q <= qty && (!best || q > parseInt(best.dataset.qty, 10))) best = b;
      });
      if (best) best.setAttribute('aria-current', 'true');
    }

    // De app-embed laadt asynchroon; we proberen het een aantal keer voordat
    // we het opgeven en de widget van de app zijn werk laten doen.
    var tries = 0;
    (function attempt() {
      var vd = findCampaigns();
      if (vd && build(vd)) return;
      // De Orichi-gegevens zijn geladen maar er is geen bruikbare staffel voor
      // dit product: dan mogen de sets meteen verschijnen, niet pas na 5 s.
      var geladen = window.orichiVolume && Array.isArray(window.orichiVolume.orichiVolumeDiscounts);
      if (vd || geladen) { toonSets(); return; }
      // Komen de gegevens helemaal niet, dan is er ook geen Orichi-widget:
      // na het opgeven verschijnen de sets alsnog.
      if (++tries > 25) { toonSets(); return; }
      setTimeout(attempt, 200);
    })();
  })();

  /* --------------------------------------------------------------------------
     5. HULPKNOPPEN
     ------------------------------------------------------------------------ */
  (function help() {
    var toggles = $$('[data-pdp-help-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.pdpHelpToggle;
        var panel = $('[data-pdp-help-panel="' + key + '"]');
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';

        // Eén paneel tegelijk: twee open panelen duwen de pagina te ver uit.
        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = $('[data-pdp-help-panel="' + b.dataset.pdpHelpToggle + '"]');
          if (p) p.hidden = true;
        });

        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });

    // Zijn we nu telefonisch bereikbaar? Bepaald in Amsterdamse tijd, zodat
    // een bezoeker uit een andere tijdzone geen onjuiste belofte ziet.
    var svc = $('[data-pdp-help-panel="service"]');
    if (svc) {
      var badge = $('[data-pdp-open]', svc);
      var text = $('[data-pdp-open-text]', svc);
      if (badge && text) {
        var from = (svc.dataset.openFrom || '08:00').split(':');
        var to = (svc.dataset.openTo || '13:00').split(':');
        var p = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Amsterdam', weekday: 'short',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
        var mins = (+p.hour % 24) * 60 + (+p.minute);
        var weekend = p.weekday === 'Sat' || p.weekday === 'Sun';
        var open = !weekend &&
                   mins >= (+from[0] * 60 + (+from[1] || 0)) &&
                   mins < (+to[0] * 60 + (+to[1] || 0));

        text.textContent = open ? (svc.dataset.lblOpen || '') : (svc.dataset.lblClosed || '');
        badge.classList.toggle('pdp-open--closed', !open);
        badge.hidden = false;
      }
    }

    // Voorgevulde adviesmail. Liquid kan de regeleindes in een mailto-body
    // niet betrouwbaar coderen, dus dat doen we hier. Er zijn er twee: de
    // knop in het koopblok en die in het adviesblok onderaan.
    $$('[data-pdp-advice-mail]').forEach(function (mail) {
      mail.href = 'mailto:' + mail.dataset.email +
                  '?subject=' + encodeURIComponent(mail.dataset.subject || '') +
                  '&body=' + encodeURIComponent(mail.dataset.body || '');
    });
  })();

  /* --------------------------------------------------------------------------
     6. UITKLAPPERS (betalen, retour, specificatiegroepen)
     ------------------------------------------------------------------------ */
  (function accordions() {
    $$('[data-pdp-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Op desktop staan de specificatiegroepen altijd open; de kop is daar
        // geen knop meer (zie de CSS) en mag dus ook niets dichtklappen.
        if (btn.closest('.pdp-specgroup') && window.matchMedia('(min-width: 900px)').matches) return;
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });

    // Beginstand van de specificatiegroepen. Op mobiel staan ze allemaal
    // dicht (5 okt 2026): de kaartjes erboven tonen de kernwaarden al, en de
    // eerste groep herhaalde daar vier van de zeven van. Op desktop staat
    // alles open. Dit gebeurt in JavaScript omdat het hidden-attribuut geen
    // media queries kent.
    var groups = $$('[data-pdp-specgroup]');
    if (!groups.length) return;

    function applyDefault() {
      var wide = window.matchMedia('(min-width: 900px)').matches;
      groups.forEach(function (g, i) {
        var head = $('.pdp-specgroup__head', g);
        var body = $('.pdp-specgroup__body', g);
        if (!head || !body) return;
        var open = wide;
        body.hidden = !open;
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    applyDefault();
    // Bij het draaien van een telefoon of het verslepen van een venster over
    // de grens heen moet de stand meebewegen, anders staat de tabel op
    // desktop half dicht zonder zichtbare knop om hem te openen.
    var mq = window.matchMedia('(min-width: 900px)');
    if (mq.addEventListener) mq.addEventListener('change', applyDefault);
    else if (mq.addListener) mq.addListener(applyDefault);
  })();

  /* --------------------------------------------------------------------------
     7. STICKY KOOPBALK
     Verschijnt zodra de echte koopknop uit beeld is. De knop in de balk klikt
     de echte knop aan, zodat er één plek is waar het toevoegen gebeurt en de
     AJAX-afhandeling van het theme intact blijft.
     ------------------------------------------------------------------------ */
  (function sticky() {
    var bar = $('[data-pdp-sticky]');
    var atc = $('[data-pdp-atc]');
    if (!bar || !atc) return;

    var stickyBtn = $('[data-pdp-sticky-atc]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }

    /* Voortgangsbalkje op de bovenrand van de balk: 0 bovenaan de pagina, vol
       helemaal onderaan. Eén transform per frame, dus geen layoutwerk tijdens
       het scrollen. */
    var voortgang = $('[data-pdp-progress]', bar);
    if (voortgang) {
      var bezig = false;
      var werkBij = function () {
        bezig = false;
        var ruimte = document.documentElement.scrollHeight - window.innerHeight;
        var deel = ruimte > 0 ? Math.min(1, Math.max(0, window.pageYOffset / ruimte)) : 0;
        voortgang.style.transform = 'scaleX(' + deel.toFixed(4) + ')';
      };
      var plan = function () {
        if (bezig) return;
        bezig = true;
        window.requestAnimationFrame(werkBij);
      };
      window.addEventListener('scroll', plan, { passive: true });
      window.addEventListener('resize', plan);
      werkBij();
    }

    if (!('IntersectionObserver' in window)) return;

    /* Op mobiel staat de balk er ook als de echte koopknop nog ónder het
       scherm staat (verzoek eigenaar, 5 okt 2026). Met de titel boven de foto
       en een vierkante foto valt de knop net onder het eerste scherm; de balk
       dekt dan de onderrand af, precies waar de prijs staat, en toont zelf de
       prijs, de teller en de knop. Scrol je verder, dan is het weer als
       voorheen: weg zolang de echte knop in beeld is, terug zodra die boven
       uit beeld raakt.

       De ondermarge is de hoogte van de balk zelf. De echte knop telt daardoor
       pas als "in beeld" wanneer hij bóven de balk uitkomt — zonder die marge
       verdwijnt de balk al bij de eerste pixel en is er even geen enkele
       koopknop te zien. Op desktop is er niets veranderd: daar staat de knop
       op het eerste scherm en verschijnt de balk alleen na het voorbijscrollen. */
    var smal = window.matchMedia('(max-width: 999px)');
    var io = null;

    function bewaak() {
      if (io) io.disconnect();
      var mobiel = smal.matches;
      var marge = mobiel ? (bar.offsetHeight || 92) : 0;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting && (mobiel || e.boundingClientRect.top < 0);
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px 0px -' + marge + 'px 0px' });
      io.observe(atc);
    }

    bewaak();
    if (smal.addEventListener) smal.addEventListener('change', bewaak);
    else if (smal.addListener) smal.addListener(bewaak);
  })();

  /* --------------------------------------------------------------------------
     8. "LEES MEER" BIJ DE OMSCHRIJVING
     ------------------------------------------------------------------------ */
  (function readMore() {
    $$('[data-pdp-more]').forEach(function (btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;

      // Past de tekst toch al binnen de hoogte, dan is de knop overbodig.
      if (target.scrollHeight <= target.clientHeight + 8) {
        target.classList.remove('pdp-rte--clamped');
        btn.hidden = true;
        return;
      }

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        target.classList.toggle('pdp-rte--clamped', open);
        $('[data-pdp-more-label]', btn).textContent = open ? btn.dataset.labelMore : btn.dataset.labelLess;
        if (open) target.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  })();

  /* --------------------------------------------------------------------------
     9. SPECIFICATIES ZOEKEN
     Bij ruim veertig velden is scrollen langs alle groepen onwerkbaar. Het
     zoekveld filtert op label én waarde, en verbergt groepen die leeg raken.
     ------------------------------------------------------------------------ */
  (function specSearch() {
    var input = $('[data-pdp-spec-search]');
    if (!input) return;

    var rows = $$('[data-pdp-specrow]');
    var groups = $$('[data-pdp-specgroup]');
    var empty = $('[data-pdp-spec-empty]');

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      rows.forEach(function (r) {
        r.hidden = q !== '' && (r.dataset.search || '').indexOf(q) === -1;
      });

      var anyVisible = false;
      groups.forEach(function (g) {
        var visible = $$('[data-pdp-specrow]', g).some(function (r) { return !r.hidden; });
        g.hidden = !visible;
        if (visible) anyVisible = true;
        // Tijdens het zoeken staan gevonden groepen open, ook op mobiel.
        if (q !== '' && visible) {
          var body = $('.pdp-specgroup__body', g);
          var head = $('.pdp-specgroup__head', g);
          if (body) body.hidden = false;
          if (head) head.setAttribute('aria-expanded', 'true');
        }
      });
      if (empty) empty.hidden = anyVisible || q === '';
    });
  })();

  /* --------------------------------------------------------------------------
     9b. UITLEG BIJ EEN VAKTERM
     De i-knopjes hadden alleen een title-attribuut. Dat verschijnt pas na een
     seconde hoveren en op een telefoon nooit, dus in de praktijk deden ze
     niets. Hier krijgen ze een echte popover die opent op klik of tik.
     ------------------------------------------------------------------------ */
  (function explain() {
    var buttons = $$('[data-pdp-explain]');
    if (!buttons.length) return;

    var pop = document.createElement('div');
    pop.className = 'pdp-pop';
    pop.setAttribute('role', 'tooltip');
    pop.hidden = true;
    document.body.appendChild(pop);

    var open = null;

    function close() {
      if (!open) return;
      open.setAttribute('aria-expanded', 'false');
      open = null;
      pop.hidden = true;
    }

    function show(btn) {
      pop.textContent = btn.dataset.pdpExplain || '';
      pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      open = btn;

      // Plaatsen onder het knopje, maar binnen het venster houden.
      var r = btn.getBoundingClientRect();
      var w = pop.offsetWidth;
      var left = r.left + r.width / 2 - w / 2;
      left = Math.max(12, Math.min(left, document.documentElement.clientWidth - w - 12));

      var top = r.bottom + window.scrollY + 8;
      // Past hij niet onder het knopje, dan erboven.
      if (r.bottom + pop.offsetHeight + 16 > window.innerHeight) {
        top = r.top + window.scrollY - pop.offsetHeight - 8;
      }
      pop.style.left = (left + window.scrollX) + 'px';
      pop.style.top = top + 'px';
    }

    buttons.forEach(function (btn) {
      // Het title-attribuut moet weg zodra JavaScript het overneemt, anders
      // verschijnt de browsertooltip alsnog over de popover heen.
      btn.removeAttribute('title');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (open === btn) { close(); return; }
        close();
        show(btn);
      });
    });

    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', close);
    window.addEventListener('scroll', close, { passive: true });
  })();

  /* --------------------------------------------------------------------------
     10. ANKERBALK
     Markeert het blok waar je naar kijkt en scrollt er zacht naartoe. De
     ankers zijn echte id's, dus een link als /products/x#specs werkt ook
     zonder JavaScript.
     ------------------------------------------------------------------------ */
  /* Een sectie die zichzelf later weghaalt laat anders een dood anker achter:
     de opruiming hieronder draait bij het laden, terwijl bijvoorbeeld het
     alternatievenblok pas verdwijnt als het aanbevelingenverzoek niets
     oplevert. Vandaar deze functie, die op dat moment alsnog het bijbehorende
     anker verwijdert — en de balk zelf als er niets overblijft. */
  window.pdpVerwijderAnker = function (id) {
    var bar = $('[data-pdp-anchorbar]');
    if (!bar) return;
    var link = $('a[href="#' + id + '"]', bar);
    if (link) link.remove();
    if (!$('a[href^="#"]', bar)) bar.remove();
  };

  (function anchors() {
    var bar = $('[data-pdp-anchorbar]');

    // De sterrenlink in het koopblok wijst naar het reviewsblok en heeft
    // dezelfde id-vertaling nodig als de balk hieronder. Die staat los van de
    // balk, dus hij wordt hier apart afgehandeld.
    var star = $('.pdp-metarow a[href^="#"]');
    if (star) {
      var starTarget = document.getElementById(star.getAttribute('href').slice(1)) ||
                       document.querySelector('[id$="__' + star.getAttribute('href').slice(1) + '"]');
      if (!starTarget) {
        // Geen reviewsblok op deze pagina: dan is de link een dood eind.
        star.removeAttribute('href');
      } else {
        star.addEventListener('click', function (e) {
          e.preventDefault();
          starTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }

    if (!bar) return;

    // Een sectie krijgt van Shopify het id shopify-section-<template>__<key>,
    // dus een anker naar een sectie die we niet zelf schrijven (het Judge.me-
    // blok) kan de volledige id niet kennen. Daarom accepteren we ook een
    // achtervoegsel.
    function resolve(id) {
      var el = document.getElementById(id) ||
               document.querySelector('[id$="__' + id + '"]');
      // Een verborgen blok (het lege reviewsblok, zie pdp-main.liquid) is
      // voor de balk hetzelfde als een blok dat er niet is.
      if (el && getComputedStyle(el).display === 'none') return null;
      return el;
    }

    // Ankers zonder doel weghalen; blijft er niets over, dan de balk zelf ook.
    // Dit kan pas hier: de balk staat bóven de blokken waarnaar hij verwijst.
    $$('a[href^="#"]', bar).forEach(function (a) {
      if (!resolve(a.getAttribute('href').slice(1))) a.remove();
    });
    if (!$('a[href^="#"]', bar)) { bar.remove(); return; }

    var links = $$('a[href^="#"]', bar);
    var targets = links.map(function (a) { return resolve(a.getAttribute('href').slice(1)); });

    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var target = targets[i];
        if (!target) return;
        e.preventDefault();
        // De sticky header van het theme plus onze eigen balk moeten er nog
        // boven passen, anders landt de kop erachter.
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - (bar.offsetHeight + headerH + 12);
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = targets.indexOf(e.target);
        if (i === -1) return;
        links.forEach(function (a, j) { a.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    targets.forEach(function (t) { if (t) io.observe(t); });
  })();

  /* --------------------------------------------------------------------------
     11. ALTERNATIEVEN — tabbladen
     ------------------------------------------------------------------------ */
  (function recommendations() {
    var grid = $('[data-pdp-recommend]');
    if (!grid) return;
    // De sets van dit product (2 PACK, 4 PACK) staan al in de pagina; de
    // aanbevelingen vullen de rij aan tot het ingestelde aantal. Het antwoord
    // van de API bevat dezelfde sets nog een keer, vandaar het ontdubbelen.
    var limiet = parseInt(grid.dataset.limit, 10) || 5;

    var url = '/recommendations/products?section_id=' + encodeURIComponent(grid.dataset.sectionId) +
              '&product_id=' + encodeURIComponent(grid.dataset.productId) +
              '&limit=' + encodeURIComponent(grid.dataset.limit || 5) +
              '&intent=related';

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-pdp-altgrid="similar"] .pdp-alt');
        var ids = $$('.pdp-alt', grid).map(function (c) { return c.dataset.productId; });
        Array.prototype.forEach.call(cards, function (c) {
          if (ids.length >= limiet) return;
          if (ids.indexOf(c.dataset.productId) !== -1) return;
          ids.push(c.dataset.productId);
          grid.appendChild(c);
        });
        if (!ids.length) throw new Error('geen kaarten');
      })
      .catch(function () {
        // Staan de sets er al, dan is de rij niet leeg en blijft hij staan.
        if (grid.querySelector('.pdp-alt')) return;
        // Geen aanbevelingen: het tabblad "Vergelijkbaar" wijst dan naar een
        // leeg vlak. Dan liever het tabblad weghalen en op het eerstvolgende
        // tabblad met inhoud beginnen.
        var tab = $('[data-pdp-alttab="similar"]');
        if (tab) tab.remove();
        grid.remove();
        var first = $('[data-pdp-alttab]');
        if (first) {
          first.setAttribute('aria-selected', 'true');
          var target = $('[data-pdp-altgrid="' + first.dataset.pdpAlttab + '"]');
          if (target) target.hidden = false;
        } else {
          // Helemaal niets te tonen: de hele sectie kan weg. Het anker in de
          // balk moet dan mee, anders blijft "Andere opties" staan als knop
          // die nergens heen springt.
          var section = $('#alternatieven');
          if (section) section.remove();
          if (window.pdpVerwijderAnker) window.pdpVerwijderAnker('alternatieven');
        }
      });
  })();

  /* --------------------------------------------------------------------------
     10c. WINKELBEOORDELINGEN OPENEN
     De winkelscore (bij de titel en onder de koopknop) opent het venster met
     alle beoordelingen van Judge.me, óp de pagina. Dat venster hoort bij het
     sterrentabje dat op desktop links aan de rand hangt; op mobiel verbergt
     de app het tabje, maar het staat wel in de pagina en een klik erop werkt
     gewoon. Geen link naar een andere pagina: wie weggaat komt minder vaak
     terug om te kopen.

     De app laadt asynchroon. De knoppen staan uit tot het tabje er is, zodat
     er nooit een knop staat die niets doet.
     ------------------------------------------------------------------------ */
  (function shopReviews() {
    var knoppen = $$('[data-pdp-shopreviews]');
    if (!knoppen.length) return;

    function tabje() { return $('.jdgm-revs-tab-btn'); }

    knoppen.forEach(function (k) {
      k.addEventListener('click', function () {
        var t = tabje();
        if (t) t.click();
      });
    });

    var tries = 0;
    (function wacht() {
      if (tabje()) { knoppen.forEach(function (k) { k.disabled = false; }); return; }
      if (++tries > 40) return;   // 12 seconden; daarna blijft het tekst
      setTimeout(wacht, 300);
    })();
  })();

  /* --------------------------------------------------------------------------
     10b. KNOP NAAR DE LICHTPLANNER
     De planner staat alleen op armaturen. Of die sectie er is weet Liquid in
     het koopblok niet, dus de knop staat verborgen in de markup en verschijnt
     hier pas als het doel echt bestaat.
     ------------------------------------------------------------------------ */
  (function planLink() {
    var link = $('[data-pdp-planlink]');
    if (!link) return;
    var doel = document.getElementById('lichtplan');
    if (!doel) return;

    link.hidden = false;

    /* Op mobiel is de planner een uitschuifpaneel (5 okt 2026); de CSS doet
       dat alleen onder 1000px én alleen met deze klasse op <html>. Zonder
       JavaScript staat de planner dus gewoon in de pagina, net als op
       desktop. */
    document.documentElement.classList.add('pdp-plan-sheet');
    var smal = window.matchMedia('(max-width: 999px)');
    var sluitknop = $('[data-plan-close]', doel);
    var open = false;
    var eigenStap = false;   // hebben wij een history-stap gezet?
    var sluitTimer = null;

    function openPaneel() {
      if (open) return;
      open = true;
      clearTimeout(sluitTimer);
      doel.classList.remove('is-sluit');
      doel.classList.add('is-open');
      doel.setAttribute('role', 'dialog');
      doel.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('pdp-sheet-open');
      // Een eigen stap in de geschiedenis: de terugknop van de telefoon sluit
      // dan het paneel in plaats van de productpagina te verlaten.
      if (window.history && history.pushState) {
        history.pushState({ pdpPlan: true }, '');
        eigenStap = true;
      }
      if (sluitknop) sluitknop.focus({ preventScroll: true });
    }

    function sluitPaneel(viaTerugknop) {
      if (!open) return;
      open = false;
      // .is-sluit draagt de overgang naar beneden; in de ruststand zit er
      // bewust geen (zie pdp-custom.css, onderdeel 20).
      doel.classList.add('is-sluit');
      doel.classList.remove('is-open');
      clearTimeout(sluitTimer);
      sluitTimer = setTimeout(function () { doel.classList.remove('is-sluit'); }, 300);
      doel.removeAttribute('role');
      doel.removeAttribute('aria-modal');
      document.documentElement.classList.remove('pdp-sheet-open');
      if (eigenStap && !viaTerugknop) { eigenStap = false; history.back(); }
      eigenStap = false;
      link.focus({ preventScroll: true });
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (smal.matches) { openPaneel(); return; }
      doel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#lichtplan');
      // De eerste maatinvoer krijgt de focus, zodat je meteen kunt typen.
      var eerste = doel.querySelector('[data-plan-l]');
      if (eerste) setTimeout(function () { eerste.focus({ preventScroll: true }); }, 500);
    });

    if (sluitknop) sluitknop.addEventListener('click', function () { sluitPaneel(false); });
    window.addEventListener('popstate', function () { sluitPaneel(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitPaneel(false); });
    // Draait de telefoon naar een breed scherm, dan staat de planner weer in
    // de pagina en hoort het paneel niet open te blijven hangen.
    function bijBreed() { if (!smal.matches) sluitPaneel(false); }
    if (smal.addEventListener) smal.addEventListener('change', bijBreed);
    else if (smal.addListener) smal.addListener(bijBreed);

    // "Leg N in mijn winkelwagen" opent de winkelwagenlade van het theme; die
    // ligt onder het paneel. Even wachten zodat "Toegevoegd" te lezen is.
    var voegToe = $('[data-plan-add]', doel);
    if (voegToe) voegToe.addEventListener('click', function () {
      if (open) setTimeout(function () { sluitPaneel(false); }, 450);
    });

    // Een directe link naar #lichtplan opent op mobiel het paneel.
    if (smal.matches && location.hash === '#lichtplan') openPaneel();
  })();

  /* --------------------------------------------------------------------------
     11b. LAATST BEKEKEN
     Het theme houdt bezochte producten bij in localStorage. We vragen deze
     sectie opnieuw op via de zoek-URL met een id:-query — hetzelfde patroon
     dat het theme zelf gebruikt — en zetten de kaarten in de grid.
     ------------------------------------------------------------------------ */
  (function recentlyViewed() {
    var root = $('[data-pdp-recent]');
    if (!root) return;

    var grid = $('[data-pdp-recent-grid]', root);
    if (!grid) return;

    var current = String(root.dataset.current || '');

    var ids;
    try {
      ids = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    } catch (e) {
      ids = [];
    }
    if (!Array.isArray(ids)) ids = [];

    // Dit bezoek zelf vastleggen. Het theme deed dat vanuit de oude
    // productsectie, en die staat er niet meer — zonder deze regels blijft de
    // geschiedenis staan op wat er vóór de nieuwe pagina in stond.
    if (current) {
      var bijgewerkt = [current].concat(ids.map(String).filter(function (id) {
        return id !== current;
      })).slice(0, 20);
      try {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(bijgewerkt.map(Number)));
      } catch (e) { /* privémodus of vol: niet erg */ }
    }

    var limit = parseInt(root.dataset.limit, 10) || 5;
    ids = ids.map(String).filter(function (id, i, arr) {
      return id !== current && arr.indexOf(id) === i;
    }).slice(0, limit);

    if (!ids.length) return;

    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    var url = '/search?type=product&q=' + encodeURIComponent(q) +
              '&section_id=' + encodeURIComponent(root.dataset.sectionId);

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-pdp-recent-grid] .pdp-alt');
        if (!cards.length) return;
        Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
        root.hidden = false;

        var clear = $('[data-pdp-recent-clear]', root);
        if (clear) {
          clear.hidden = false;
          clear.addEventListener('click', function () {
            try { localStorage.removeItem('recentlyViewedProducts'); } catch (e) {}
            root.hidden = true;
          });
        }
      })
      .catch(function () { /* geen geschiedenis te tonen: sectie blijft verborgen */ });
  })();

  (function altTabs() {
    var tabs = $$('[data-pdp-alttab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.pdpAlttab;
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        $$('[data-pdp-altgrid]').forEach(function (g) {
          g.hidden = g.dataset.pdpAltgrid !== key;
        });
      });
    });
  })();

  /* --------------------------------------------------------------------------
     11c. KOOPKNOP OP EEN PRODUCTKAART
     Eén stuk in de winkelwagen zonder de productpagina te verlaten. De
     kaarten komen deels later binnen (aanbevelingen, eerder bekeken), dus de
     klik wordt op het document afgevangen. Na het toevoegen sturen we het
     event waarop het theme zijn winkelwagen bijwerkt en opent — zo
     beschreven bovenin assets/custom.js.
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-pdp-kaart-add]');
    if (!knop || knop.disabled) return;
    e.preventDefault();

    var basis = (window.routes && window.routes.cartAddUrl) || '/cart/add';
    knop.disabled = true;

    fetch(basis + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(knop.dataset.variantId), quantity: 1 })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function () {
        knop.classList.add('is-klaar');
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1 }
        }));
        setTimeout(function () { knop.classList.remove('is-klaar'); knop.disabled = false; }, 1600);
      })
      .catch(function () {
        // Niet gelukt (uitverkocht geraakt, netwerk): dan gewoon naar het
        // product, daar staat wat er aan de hand is.
        var link = knop.parentNode.querySelector('.pdp-alt__link');
        if (link) window.location.href = link.href;
        else knop.disabled = false;
      });
  });

  /* --------------------------------------------------------------------------
     11d. DESKTOP: ONDERDELEN OP HUN PLEK ZETTEN
     Twee blokken staan op desktop ergens anders dan in de markup:
       - de kerngetallen (tegels) uit de specificatiesectie staan direct onder
         de foto, in "in één oogopslag";
       - de besparingsrekenaar uit de omschrijving staat naast de rekenhulp.
     Ze worden verplaatst en niet dubbel gerenderd: zo is er één exemplaar,
     met de labels en vertalingen van de sectie waar het vandaan komt. Een
     onzichtbaar merkteken houdt de oude plek vast, zodat alles terug kan
     zodra het scherm smaller wordt dan 1000px. Zonder JavaScript blijft
     alles waar het in de markup staat.

     Ook hier: de hoogte van de koopkaart als CSS-variabele. De kaart loopt
     op desktop mee; op een laag scherm gebruikt de CSS die hoogte om hem met
     zijn onderkant op de schermrand te laten plakken (onderdeel 22).
     ------------------------------------------------------------------------ */
  (function desktopIndeling() {
    var breed = window.matchMedia('(min-width: 1000px)');
    var verhuizingen = [
      { bron: '.pdp-section-specs .pdp-keyspecs, [data-pdp-slot="keyspecs"] .pdp-keyspecs', vak: '[data-pdp-slot="keyspecs"]' },
      { bron: '[data-pdp-calc]', vak: '[data-pdp-slot="calc"]' }
    ].map(function (v) {
      var el = $(v.bron);
      var vak = $(v.vak);
      if (!el || !vak) return null;
      var merk = document.createComment('pdp-plek');
      el.parentNode.insertBefore(merk, el);
      return { el: el, vak: vak, merk: merk };
    }).filter(Boolean);

    function zetNeer() {
      verhuizingen.forEach(function (v) {
        if (breed.matches) {
          if (v.el.parentNode !== v.vak) v.vak.appendChild(v.el);
        } else if (v.el.parentNode === v.vak) {
          v.merk.parentNode.insertBefore(v.el, v.merk.nextSibling);
        }
      });
    }
    zetNeer();
    if (breed.addEventListener) breed.addEventListener('change', zetNeer);
    else if (breed.addListener) breed.addListener(zetNeer);

    var kaart = $('.pdp-buybox');
    if (kaart) {
      /* Buitenverlichting (.pdp-wrap--kaart-vast): past de kaart niet in het
         venster onder de header, dan loopt hij niet mee (.is-te-hoog, zie
         pdp-custom.css). Zelfde maat als de sticky-regel: header + 16 px
         boven en 16 px onder. Elders verandert er niets. */
      var vastWrap = kaart.closest('.pdp-wrap--kaart-vast');
      var meetKaart = function () {
        var h = kaart.offsetHeight;
        document.documentElement.style.setProperty('--pdp-kaart-h', h + 'px');
        if (vastWrap) {
          var kop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          kaart.classList.toggle('is-te-hoog', breed.matches && h > window.innerHeight - kop - 32);
        }
      };
      // Meteen één keer, en daarna bij elke verandering van hoogte (staffel
      // die binnenkomt, een uitklapper in de voet van de kaart).
      meetKaart();
      if ('ResizeObserver' in window) new ResizeObserver(meetKaart).observe(kaart);
      else window.addEventListener('resize', meetKaart);
      if (vastWrap && 'ResizeObserver' in window) window.addEventListener('resize', meetKaart);
    }
  })();

  /* --------------------------------------------------------------------------
     12. BESPARINGSREKENAAR
     Rekent uitsluitend met wat de klant zelf invult en met het vermogen van
     dit product. We beloven dus niets over de opbrengst — het is een som die
     de bezoeker zelf kan narekenen.
     ------------------------------------------------------------------------ */
  (function calculator() {
    var root = $('[data-pdp-calc]');
    if (!root) return;

    var watt = parseFloat(root.dataset.watt || '0');
    if (!watt) { root.hidden = true; return; }

    var oldW = $('[data-calc-old]', root);
    var count = $('[data-calc-count]', root);
    var hours = $('[data-calc-hours]', root);
    var rate = $('[data-calc-rate]', root);
    var outYear = $('[data-calc-year]', root);
    var outKwh = $('[data-calc-kwh]', root);

    function calc() {
      var o = parseFloat(oldW.value) || 0;
      var n = parseFloat(count.value) || 0;
      var h = parseFloat(hours.value) || 0;
      var r = parseFloat(String(rate.value).replace(',', '.')) || 0;

      var saveW = Math.max(0, o - watt);
      var kwh = saveW * n * h * 365 / 1000;
      var euro = kwh * r;

      if (outKwh) outKwh.textContent = kwh.toFixed(0);
      if (outYear) outYear.textContent = money(Math.round(euro * 100));
    }

    [oldW, count, hours, rate].forEach(function (el) {
      if (el) el.addEventListener('input', calc);
    });
    calc();
  })();

  /* --------------------------------------------------------------------------
     11e. PASSENDE LICHTBRON
     De rij lichtbronnen onder de koopknop van een armatuur zonder lichtbron
     (snippets/pdp-lichtbron.liquid). Per kaartje één knop die het benodigde
     aantal toevoegt; daarna wordt de knop een teller met het aantal dat in de
     winkelwagen ligt.

     - De lade blijft dicht: we sturen cart:refresh (teller in de header en
       inhoud van de lade bijwerken) en niet product:added (dat opent de lade
       en scrolt naar boven). De bezoeker heeft de lamp zelf vaak nog niet
       toegevoegd.
     - Het benodigde aantal is fittingen x aantal armaturen. Het aantal
       armaturen lezen we alleen bij een change/input-event van het
       hoofdveld: Orichi schrijft bij het laden stil een staffelaantal in dat
       veld, en dat is geen keuze van de bezoeker.
     - Bij een fout blijft de bezoeker op de pagina; de melding staat onder
       de rij.
     ------------------------------------------------------------------------ */
  (function lichtbron() {
    var root = $('[data-pdp-lbron]');
    if (!root) return;

    var d = root.dataset;
    var fit = parseInt(d.fittingen, 10) || 1;
    var rij = $('[data-pdp-lbron-rij]', root);
    var status = $('[data-pdp-lbron-status]', root);
    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var lampAantal = 1;
    var kopTeller = $('.header__cart-count');

    var kaarten = $$('[data-pdp-lbron-kaart]', root).map(function (el) {
      return {
        el: el,
        id: Number(el.dataset.variantId),
        pack: parseInt(el.dataset.pack, 10) || 1,
        max: el.dataset.max ? Math.max(0, parseInt(el.dataset.max, 10) || 0) : Infinity,
        naam: el.dataset.naam || '',
        knop: $('[data-pdp-lbron-add]', el),
        tekst: $('[data-pdp-lbron-knoptekst]', el),
        teller: $('[data-pdp-lbron-teller]', el),
        getal: $('[data-pdp-lbron-getal]', el),
        inWagen: 0,
        sleutel: null,
        bezig: false
      };
    });
    if (!kaarten.length) return;

    function nodig(k) {
      return Math.max(1, Math.min(10, Math.ceil(fit * lampAantal / k.pack)));
    }
    function knopTekst(k) {
      var n = nodig(k);
      if (k.pack > 1) return n === 1 ? d.lblAddSet : d.lblAddSets.replace('[[n]]', n);
      return n === 1 ? d.lblAdd : d.lblAddN.replace('[[n]]', n);
    }
    function teken(k) {
      var heeft = k.inWagen > 0;
      k.knop.hidden = heeft;
      k.teller.hidden = !heeft;
      k.getal.textContent = k.inWagen;
      k.tekst.textContent = knopTekst(k);
    }
    function zetBezig(k, aan) {
      k.bezig = aan;
      if (aan) k.knop.setAttribute('aria-disabled', 'true');
      else k.knop.removeAttribute('aria-disabled');
      k.teller.classList.toggle('is-bezig', aan);
    }
    function meld(tekst, fout) {
      status.textContent = tekst || '';
      status.classList.toggle('is-fout', !!fout);
    }
    function statusTekst(k) {
      return d.lblStatus.replace('[[n]]', k.inWagen).replace('[[naam]]', k.naam);
    }
    function foutTekst(e) {
      return (e && e.status === 422 && e.data && e.data.description) || d.lblError;
    }

    function post(pad, body) {
      return fetch(basis + pad, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          return r.ok ? j : Promise.reject({ status: r.status, data: j });
        });
      });
    }
    function verwerk(cart) {
      kaarten.forEach(function (k) { k.inWagen = 0; k.sleutel = null; });
      (cart.items || []).forEach(function (regel) {
        kaarten.forEach(function (k) {
          if (regel.variant_id !== k.id) return;
          k.inWagen += regel.quantity;
          if (!k.sleutel) k.sleutel = regel.key;
        });
      });
      kaarten.forEach(teken);
      /* De teller in de header. Het theme leest het aantal bij cart:refresh
         uit het eerste kind van de lade-sectie, maar dat is een <style>: de
         teller blijft dan op de oude waarde staan. Wij weten het echte
         aantal, dus zetten we het hier. */
      if (kopTeller && String(kopTeller.textContent).trim() !== String(cart.item_count)) {
        kopTeller.textContent = cart.item_count;
      }
      return cart;
    }
    function lees() {
      return fetch(basis + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(verwerk);
    }
    function ververs() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
    }
    function log(naam, k, aantal) {
      try {
        (window.dataLayer = window.dataLayer || []).push({ event: naam, lb_variant: k ? k.id : undefined, lb_aantal: aantal });
        if (typeof window.clarity === 'function') window.clarity('event', naam);
      } catch (e) { /* meten mag het toevoegen nooit breken */ }
    }

    function voegToe(k) {
      if (k.bezig) return;
      var n = Math.min(nodig(k), k.max);
      if (n < 1) { meld(d.lblSoldout, true); return; }
      var hadFocus = document.activeElement === k.knop;
      zetBezig(k, true);
      post('cart/add.js', { id: k.id, quantity: n })
        .then(lees)
        .then(function () {
          meld(statusTekst(k));
          ververs();
          log('lb_toegevoegd', k, n);
          if (hadFocus) { var plus = $('[data-pdp-lbron-stap="1"]', k.el); if (plus) plus.focus(); }
        })
        .catch(function (e) { meld(foutTekst(e), true); })
        .then(function () { zetBezig(k, false); });
    }

    function stap(k, delta) {
      if (k.bezig || !k.sleutel) return;
      var n = Math.max(0, k.inWagen + delta);
      if (delta > 0 && n > k.max) { meld(d.lblSoldout, true); return; }
      zetBezig(k, true);
      post('cart/change.js', { id: k.sleutel, quantity: n })
        .then(verwerk)
        .then(function () {
          meld(k.inWagen > 0 ? statusTekst(k) : '');
          ververs();
          log('lb_aantal_gewijzigd', k, k.inWagen);
          if (k.inWagen === 0) k.knop.focus();
        })
        .catch(function (e) { meld(foutTekst(e), true); })
        .then(function () { zetBezig(k, false); });
    }

    root.addEventListener('click', function (e) {
      var doel = e.target.closest('[data-pdp-lbron-add], [data-pdp-lbron-stap], [data-pdp-lbron-pijl]');
      if (!doel) return;
      if (doel.hasAttribute('data-pdp-lbron-pijl')) {
        rij.scrollBy({ left: Number(doel.dataset.pdpLbronPijl) * rij.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }
      var el = doel.closest('[data-pdp-lbron-kaart]');
      var k = kaarten.filter(function (x) { return x.el === el; })[0];
      if (!k) return;
      if (doel.hasAttribute('data-pdp-lbron-add')) voegToe(k);
      else stap(k, Number(doel.dataset.pdpLbronStap));
    });

    /* Aantal armaturen volgen (zie de kop van dit onderdeel). */
    var hoofdveld = $('[data-pdp-qty-input]');
    if (hoofdveld) {
      var volg = function () {
        lampAantal = Math.max(1, parseInt(hoofdveld.value, 10) || 1);
        kaarten.forEach(teken);
      };
      hoofdveld.addEventListener('change', volg);
      hoofdveld.addEventListener('input', volg);
    }

    /* Pijlen: grijs aan het begin en het eind van de rij. */
    var pijlen = $$('[data-pdp-lbron-pijl]', root);
    if (pijlen.length && rij) {
      var zetPijlen = function () {
        var eind = rij.scrollWidth - rij.clientWidth - 2;
        pijlen.forEach(function (p) {
          var uit = Number(p.dataset.pdpLbronPijl) < 0 ? rij.scrollLeft <= 2 : rij.scrollLeft >= eind;
          if (uit) p.setAttribute('aria-disabled', 'true'); else p.removeAttribute('aria-disabled');
        });
      };
      rij.addEventListener('scroll', zetPijlen, { passive: true });
      zetPijlen();
    }

    /* Wat al in de wagen ligt meteen als teller tonen, ook na "terug" in de
       browser en als de bezoeker in de lade iets weghaalt (de teller in de
       header verandert dan). Verandert er niets, dan stopt het vanzelf. */
    lees().catch(function () {});
    window.addEventListener('pageshow', function (e) { if (e.persisted) lees().catch(function () {}); });
    if (kopTeller && 'MutationObserver' in window) {
      var wacht;
      new MutationObserver(function () {
        clearTimeout(wacht);
        wacht = setTimeout(function () { lees().catch(function () {}); }, 80);
      }).observe(kopTeller, { childList: true, characterData: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      var kijk = new IntersectionObserver(function (items) {
        if (!items[0].isIntersecting) return;
        kijk.disconnect();
        log('lb_blok_gezien');
      }, { threshold: 0.5 });
      kijk.observe(root);
    }
  })();

})();
